export default __webpack_public_path__ + "static/MediaContentEight-f0d7e41a0a7dff9c17acbd3fbed16217.webp";